import React, {useState} from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Widget from "../../../../../components/prefabricated/Widget";
import BBIconConstructionTie from "../../../../../assets/bbCustomIcons/BBIconConstructionTie";
import {bbConstructionCone} from "../../../../../util/bbHelpers";


const ComingSoon = (props) => {

  const [expanded, setExpanded] = useState(null);

  const handleChange = panel => (event, expanded) => {
    setExpanded(() => expanded ? panel : false)
  };

  return (
      <div className={`bb-tab-section`}>
      {/*<ContainerHeader title={"Coming Soon: Controls"} match={props.match}/>*/}
        <h3>{bbConstructionCone()} CMMC Reports</h3>
        <p><strong>Reports</strong> help your team conduct gap analysis, pre-assessment, and easily provide <strong>Objective Evidence</strong> to your internal assessment team and your CMMC Assessors.</p>

        <div className="row">
        <div className={"col-12"}>
          <Widget>
            <div className="d-flex justify-content-around">


              <div className="row">
                <div className={"col-9"}>
                  <h2>This feature is under construction</h2>
                  <p>The CMMC Reports feature is under construction.  We'd love your feedback or to hear about the types of funcitonality that you'd like to see in this feature. <a href={"mailto:support@breachbits.com"}>Send us feedback to support@breachbits.com</a></p>
                  <p>You've been granted early access to this module, and we hope you don't mind the dust as we rapidly build and improve useful features. Thanks for your patience!</p>
                </div>
              <div className={"col-3"}>
                <BBIconConstructionTie style={{fontSize: 130}} />
              </div>
              </div>


            </div>
          </Widget>
        </div>
      </div>
      <div className="row">
        <div className="col-12 mb-4 mb-md-0">

          <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              What are Controls?
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <p>Controls are activities that impose obstacles for attackers and typically reduce risk. While they don't directly reduce the risk of a given Vector, these best practices are historically correlated to secure companies. Typically, the more controls you have, the lower your overall risk will be.</p>
                <p>In the natural course of attempting to hack your systems, we encounter (or don't encounter) these controls.  For example, if we attempt to guess 1000 passwords in an hour, but your system will only allow us to submit 20, then we have encountered the control and must adjust our tactics accordingly.</p>

              </div>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              What is Objective Evidence?
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <p>According to the CMMC Certification standard, during your assessment phase you will be required to provide Objective Evidence that each of the CMMC Practices in your desired Maturity Level are being conducted now, and have been conducted in the past.</p>

              </div>

            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              Is BreachBits qualified to help me with CMMC?
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <p>BreachBits is <a target="_blank" href={"https://cmmcab.org/marketplace/breachbits-inc-rpo/"}>credentialed as a Register Provider Organization (RPO)</a> by the CMMC Accreditation Board. Although you don't have to use a credentialed organization to help
                you navigate CMMC, RPOs and Registered Practitioners (RPs) have been vetted by the CMMC AB, and have successfully completed training specifically related to the CMMC standard. </p>


              </div>

            </AccordionDetails>

          </Accordion>
          <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              What Practices can BreachBits automatically verify?
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <p>The nature of BreachBits technology allows for the automatic detection and logging of data that can provide Objective Evidence that a CMMC Practice is being implemented.  Use BreachBits to shorten your assessment cycle and reduce costs.  Verification is different from "satisfaction."</p>

              </div>

            </AccordionDetails>

          </Accordion>
          <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              What Practices can BreachBits automatically satisfy?
            </AccordionSummary>
            <AccordionDetails>
              <div>
                <p>By subscribing to the BreachBits CMMC compliance module, BreachBits technology is automatically satisfying some CMMC practices.</p>

              </div>

            </AccordionDetails>

          </Accordion>

        </div>
      </div>
    </div>
  );
};

export default ComingSoon;

